<template>
  <div class="faqs">
    <!-- Page Header -->
    <div class="faqs-header">
      <div class="faqs-header-bg"></div>
      <div class="faqs-header-content">
        <h1>FAQs</h1>
        <p>Find answers to common questions</p>
      </div>
    </div>

    <div class="faqs-body">
      <div class="faqs-grid">
        <section ref="shoppingSection" class="faqs-section">
          <div class="section-icon">🛍️</div>
          <h2>Shopping Information</h2>
          <el-collapse v-model="activeShopping" class="lili-collapse">
            <el-collapse-item
              v-for="item in shoppingFaqs"
              :key="item.id"
              :title="item.question"
              :name="item.id"
            >
              <div class="faqs-answer" v-html="item.answer"></div>
            </el-collapse-item>
          </el-collapse>
        </section>
        <section ref="returnSection" class="faqs-section">
          <div class="section-icon">🔄</div>
          <h2>Returns & Cancellations</h2>
          <el-collapse v-model="activeReturn" class="lili-collapse">
            <el-collapse-item
              v-for="item in returnFaqs"
              :key="item.id"
              :title="item.question"
              :name="item.id"
            >
              <div class="faqs-answer" v-html="item.answer"></div>
            </el-collapse-item>
          </el-collapse>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Faqs',
  data() {
    return {
      activeShopping: [],
      activeReturn: [],
      shoppingFaqs: [
        {
          id: 's1',
          question: 'How long does delivery take?',
          answer:
            '<p>Delivery time depends on your location:</p>' +
            '<ul>' +
            '<li>Metro Cities: 3–5 working days</li>' +
            '<li>Other Cities: 5–7 working days</li>' +
            '<li>Remote Areas: 7–10 working days</li>' +
            '</ul>' +
            '<p>You will receive a tracking link once your order is shipped.</p>'
        },
        {
          id: 's2',
          question: 'Do you offer free shipping?',
          answer:
            '<p>Yes, we offer free shipping on selected products and minimum order values. The final shipping charge will be shown at checkout.</p>'
        },
        {
          id: 's3',
          question: 'How can I track my order?',
          answer:
            '<p>Once dispatched, you will receive SMS/Email with a tracking ID.</p>' +
            '<p>You can also track it via:</p>' +
            '<p>My Account → Orders → Track Order</p>'
        },
        {
          id: 's4',
          question: 'What if my package is delayed?',
          answer:
            '<p>Delays may occur due to festivals, weather, or courier issues.</p>' +
            '<p>If your order is delayed over the expected timeline, contact us at:</p>' +
            '<p>📞 +91 9802567810</p>' +
            '<p>✉️ khadeerveldigii01@gmail.com</p>'
        },
        {
          id: 's5',
          question: 'What should I do if my order arrives damaged?',
          answer:
            '<p>If your parcel arrives damaged or tampered:</p>' +
            '<ul>' +
            '<li>Record a parcel opening video</li>' +
            '<li>Contact support within 24 hours</li>' +
            '</ul>' +
            '<p>We will assist with replacement as per policy.</p>'
        },
        {
          id: 's6',
          question: 'What happens if I miss the delivery attempt?',
          answer:
            '<p>If you are unavailable during delivery, the courier partner will make 2–3 re-attempts.</p>' +
            '<p>You can also contact the courier using your tracking ID to schedule a convenient delivery time.</p>'
        }
      ],
      returnFaqs: [
        {
          id: 'r1',
          question: 'What is your return policy?',
          answer:
            '<p>We offer 7-day return/replacement for eligible products in case of:</p>' +
            '<ul>' +
            '<li>Wrong product delivered</li>' +
            '<li>Size issue (where applicable)</li>' +
            '<li>Damaged product</li>' +
            '</ul>' +
            '<p>Note: Items like socks, stockings, dupatta, scarf, and hygiene-sensitive items are non-returnable.</p>'
        },
        {
          id: 'r2',
          question: 'How do I initiate a return or replacement?',
          answer:
            '<p>Go to:</p>' +
            '<p>My Account → Orders → Request Return/Replace</p>' +
            '<p>Upload required photos/video and submit the request.</p>'
        },
        {
          id: 'r3',
          question: 'Are refunds available?',
          answer:
            '<p>Yes. Refunds are issued after QC approval:</p>' +
            '<ul>' +
            '<li>Prepaid orders: Refunded to original payment method</li>' +
            '<li>COD orders: Refunded via bank transfer or wallet credit</li>' +
            '</ul>' +
            '<p>Refund processing time: 5–7 working days</p>'
        },
        {
          id: 'r4',
          question: 'Can I cancel my order?',
          answer:
            '<p>You may cancel anytime before the order is shipped.</p>' +
            '<p>Once shipped, cancellations are not allowed.</p>'
        },
        {
          id: 'r5',
          question: 'How do I cancel my order?',
          answer:
            '<p>Go to:</p>' +
            '<p>My Account → Orders → Cancel Order</p>' +
            '<p>Or contact customer support immediately.</p>'
        },
        {
          id: 'r6',
          question: 'Can I change the delivery address after placing the order?',
          answer:
            '<p>Address changes are possible only before dispatch.</p>' +
            '<p>Contact us quickly through phone or email.</p>'
        },
        {
          id: 'r7',
          question: 'What if my return is rejected?',
          answer:
            '<p>A return may be rejected if:</p>' +
            '<ul>' +
            '<li>Product is used, washed, or altered</li>' +
            '<li>Tags/packaging are missing</li>' +
            '<li>Incorrect or incomplete proof is provided</li>' +
            '</ul>' +
            '<p>Ineligible returns will be shipped back to the customer.</p>'
        }
      ]
    }
  },
  created() {
    this.applySection()
  },
  watch: {
    $route() {
      this.applySection()
    }
  },
  methods: {
    applySection() {
      const section = this.$route.query.section
      if (section === 'shopping') {
        this.activeShopping = ['s1']
        this.activeReturn = []
        return
      }
      if (section === 'returns') {
        this.activeReturn = ['r1']
        this.activeShopping = []
      }
    }
  }
}
</script>

<style scoped>
.faqs {
  background: #FDF3EE;
  min-height: 100vh;
}

/* Page Header */
.faqs-header {
  position: relative;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.faqs-header-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, #3B211C 0%, #2A1611 50%, #FAF5EC 100%);
}
.faqs-header-bg::after {
  content: '';
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.faqs-header-content {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 0 20px;
}
.faqs-header-content h1 {
  font-size: 42px;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.faqs-header-content p {
  font-size: 18px;
  color: rgba(255,255,255,0.9);
}

/* Body */
.faqs-body {
  max-width: 1200px;
  margin: 0 auto;
  padding: 50px 24px 80px;
}
.faqs-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}
.faqs-section {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 18px 40px rgba(59,33,28, 0.08);
}
.section-icon {
  font-size: 36px;
  margin-bottom: 16px;
}
.faqs-section h2 {
  font-size: 18px;
  font-weight: 700;
  color: #2D2D2D;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #FBE3DE;
}
.faqs-answer {
  color: #666666;
  font-size: 14px;
  line-height: 1.7;
}
.faqs-answer p {
  margin: 0 0 10px;
}
.faqs-answer ul {
  margin: 0 0 12px 18px;
  padding: 0;
}
.faqs-answer li {
  margin-bottom: 6px;
}

/* Element UI Collapse Override */
.lili-collapse {
  border: none;
}
.lili-collapse /deep/ .el-collapse-item__header {
  background: transparent;
  border-bottom: 1px solid #FBE3DE;
  color: #2D2D2D;
  font-weight: 600;
  font-size: 14px;
  padding: 14px 0;
}
.lili-collapse /deep/ .el-collapse-item__wrap {
  background: transparent;
  border-bottom: none;
}
.lili-collapse /deep/ .el-collapse-item__content {
  padding: 16px 0 8px;
  color: #666666;
  font-size: 14px;
  line-height: 1.7;
}
.lili-collapse /deep/ .el-collapse-item__header:hover {
  color: #3B211C;
}
.lili-collapse /deep/ .el-collapse-item__arrow {
  color: #3B211C;
}

@media (max-width: 1024px) {
  .faqs-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}
@media (max-width: 900px) {
  .faqs-header {
    height: 200px;
  }
  .faqs-header-content h1 {
    font-size: 28px;
  }
  .faqs-header-content p {
    font-size: 14px;
  }
  .faqs-body {
    padding: 30px 12px 60px;
  }
  .faqs-section {
    padding: 24px;
    border-radius: 12px;
  }
}
</style>
